angular.module('bmsApp.settings').controller('MailchimpSettingsCtrl', [
	'$scope',
	'SettingSvc',
	'MailchimpSvc',
	'AppSettingsSvc',
	//'vAccordion',
	//'$stateParams',
	//'$state',
	function ($scope, SettingSvc, MailchimpSvc, AppSettingsSvc) {
		$scope.data = {};
		$scope.loaded = false;
		$scope.valid = true;
		$scope.show_valid = false;

		AppSettingsSvc.index()
			.then(function (response) {
				$scope.settingData = response.data.settings;

				if ($scope.settingData.mailchimp_apikey && $scope.settingData.mailchimp_apikey_verified == 1) {
					$scope.show_valid = true;
					return MailchimpSvc.getTemplate();
				}
				$scope.loaded = true;

			})
			.then(function (response) {
				console.log(response);
			});


		$scope.submit = function () {
			MailchimpSvc
				.verifyApiKey($scope.settingData)
				.then(function (response) {
					data = response.data;
					$scope.show_valid = true;
					$scope.valid = data.valid;
					MailchimpSvc.getTemplate();
					// MailchimpSvc.getTemplate();
				});
		}


	}]);
